<template>
  <!--begin::Main-->
  <div class="d-flex flex-column flex-root">
    <!--begin::Authentication - Sign-up -->
    <div class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      <!--begin::Content-->
      <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        <!--begin::Logo-->
        <a href="#" class="mb-5">
          <img alt="Logo" :src="'/admin/images/logo_mostra.png'"
               class="h-100px"/>
        </a>
        <!--end::Logo-->

        <!--begin::Wrapper-->
        <div class="w-lg-600px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">

          <!--begin::Form-->
          <form
              class="form w-100"
              novalidate="novalidate"
              id="kt_sign_up_form"
              @submit.prevent="form.post(this.route('register'))"
          >
            <!--begin::Heading-->
            <div class="mb-10 text-center">
              <!--begin::Title-->
              <h1 class="text-dark mb-3">Criar conta</h1>
              <!--end::Title-->
              <!--begin::Link-->
              <div class="text-gray-400 fw-bold fs-4">Já possui uma conta
                <a :href="route('login')" class="link-primary fw-bolder">
                  Faça o login
                </a>
              </div>
              <!--end::Link-->
            </div>
            <!--end::Heading-->

            <!--begin::Input group-->
            <div class="fv-row mb-7">
              <form-group label="Nome" :is-invalid="form.errors.name">
                <input
                    v-model="form.name"
                    class="form-control form-control-lg form-control-solid"
                    type="text"
                    placeholder="Seu nome completo"
                    autocomplete="off"
                    @blur="form.clearErrors('name')"
                    :class="{'is-invalid': form.errors.name}"
                />
              </form-group>
            </div>
            <!--end::Input group-->
            <!--begin::Input group-->
            <div class="row mb-7">
              <div class="col">
                <form-group label="Telefone" :is-invalid="form.errors.telefone">
                  <input
                      v-model="form.telefone"
                      class="form-control form-control-lg form-control-solid phone"
                      type="text"
                      placeholder="Telefone"
                      v-input-mask
                      data-inputmask="'mask': '(99) 9 9999-9999', 'placeholder': '', 'removeMaskOnSubmit': true, 'showMaskOnHover': false, 'showMaskOnFocus': false"
                      @blur="form.clearErrors('telefone')"
                      :class="{'is-invalid': form.errors.telefone}"
                  />
                </form-group>
              </div>

              <div class="col">
                <form-group label="CPF" :is-invalid="form.errors.cpf">
                  <input
                      v-model="form.cpf"
                      class="form-control form-control-lg form-control-solid"
                      type="text"
                      placeholder="CPF"
                      v-input-mask
                      data-inputmask="'mask': '999.999.999-99', 'placeholder': '', 'removeMaskOnSubmit': true, 'showMaskOnHover': false, 'showMaskOnFocus': false"
                      @blur="form.clearErrors('cpf')"
                      :class="{'is-invalid': form.errors.cpf}"
                  />
                </form-group>
              </div>
            </div>

            <div class="row mb-7">
              <div class="col">
                <form-group label="Camiseta" required :is-invalid="form.errors.camiseta">
                  <select class="form-select" v-model="form.camiseta"
                          @change="form.clearErrors('camiseta')"
                          :class="{'is-invalid' : form.errors.camiseta}">
                    <option value="P">P</option>
                    <option value="M">M</option>
                    <option value="G">G</option>
                    <option value="GG">GG</option>
                  </select>
                </form-group>
              </div>

              <div class="col">
                <div class="col">
                  <form-group label="Gênero" required :is-invalid="form.errors.genero">
                    <select class="form-select" v-model="form.genero"
                            data-dropdown-parent="#modal_aluno"
                            @change="form.clearErrors('genero')"
                            :class="{'is-invalid' : form.errors.genero}">
                      <option value="F">Feminino</option>
                      <option value="M">Masculino</option>
                      <option value="O">Outro</option>
                    </select>
                  </form-group>
                </div>
              </div>
            </div>

            <div class="row mb-7">
              <div class="col">
                <form-group label="Titulação" required :is-invalid="form.errors.titulacao">
                  <select class="form-select" v-model="form.titulacao"
                          @change="form.clearErrors('titulacao')"
                          :class="{'is-invalid' : form.errors.titulacao}">
                    <option value="1">Graduação</option>
                    <option value="2">Especialização</option>
                    <option value="3">Mestrado</option>
                    <option value="4">Doutorado</option>
                  </select>
                </form-group>
              </div>

              <div class="col">
                <form-group label="Formação" required :is-invalid="form.errors.formacao">
                  <select class="form-select" v-model="form.formacao"
                          @change="form.clearErrors('formacao')" data-placeholder="Selecione uma opção" v-select2 data-control="select2">
                    <option></option>
                    <option v-for="formacao in formacoes" :value="formacao.id" >{{ formacao.nome }}</option>
                  </select>
                </form-group>
              </div>
            </div>
            <!--end::Input group-->
            <!--begin::Input group-->
            <div class="fv-row mb-7">
              <form-group label="E-mail" :is-invalid="form.errors.email">
                <input
                    v-model="form.email"
                    class="form-control form-control-lg form-control-solid"
                    type="email"
                    placeholder="Informe um e-mail válido e em funcionamento"
                    autocomplete="off"
                    @blur="form.clearErrors('email')"
                    :class="{'is-invalid': form.errors.email}"
                />
              </form-group>
            </div>
            <!--end::Input group-->
            <!--begin::Input group-->
            <div class="mb-10 fv-row" data-kt-password-meter="true">
              <!--begin::Wrapper-->
              <div class="mb-1">
                <form-group label="Senha" :is-invalid="form.errors.password">
                  <div class="position-relative mb-3">
                    <input
                        v-model="form.password"
                        class="form-control form-control-lg form-control-solid"
                        type="password"
                        placeholder="Informe a sua senha"
                        autocomplete="off"
                        @blur="form.clearErrors('password')"
                        :class="{'is-invalid': form.errors.password}"
                    />
                    <span
                        class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                        data-kt-password-meter-control="visibility">
                                            <i class="bi bi-eye-slash fs-2"></i>
                                            <i class="bi bi-eye fs-2 d-none"></i>
                                        </span>
                  </div>
                </form-group>

              </div>
              <!--end::Wrapper-->
            </div>
            <div class="text-center">
              <submit-button :processing="form.processing" label="Criar conta"></submit-button>
            </div>
            <!--end::Actions-->
          </form>
          <!--end::Form-->
        </div>
        <!--end::Wrapper-->
      </div>
      <footer-auth/>
    </div>
  </div>
  <!--end::Main-->
</template>

<script>
import FooterAuth from "./FooterAuth";
import FormGroup from "@forms/FormGroup";
import SubmitButton from "@forms/SubmitButton";
import {useForm} from "@inertiajs/inertia-vue3";
import axios from "axios";

export default {
  components: {
    FormGroup,
    FooterAuth,
    SubmitButton
  },

  data: _ => ({
    formacoes: []
  }),

  setup() {
    const form = useForm({
      name: '',
      telefone: '',
      email: '',
      camiseta: '',
      genero: '',
      formacao: '',
      titulacao: '',
      cpf: '',
      password: ''
    });

    return {form};
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      axios.get(this.route('site.formacoes')).then(response => this.formacoes = response.data)
    }
  }
}
</script>
